// extracted by mini-css-extract-plugin
export default {"root":"DatatypeCreateForm_root__4DiWr","after":"DatatypeCreateForm_after__yo8aF","header":"DatatypeCreateForm_header__kG8vA"};